var _rect, _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#1C6947"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_10248_2012",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40137 7.5957H10.8154V8.4043H8.40137H7.58691H5.18457V7.5957H7.58691H8.40137Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40137 7.5957H10.8154V8.4043H8.40137H7.58691H5.18457V7.5957H7.58691H8.40137Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8154 7.5957H11.8154V6.5957H10.8154V7.5957ZM10.8154 8.4043V9.4043H11.8154V8.4043H10.8154ZM5.18457 8.4043H4.18457V9.4043H5.18457V8.4043ZM5.18457 7.5957V6.5957H4.18457V7.5957H5.18457ZM8.40137 7.5957V8.5957H10.8154V7.5957V6.5957H8.40137V7.5957ZM10.8154 7.5957H9.81543V8.4043H10.8154H11.8154V7.5957H10.8154ZM10.8154 8.4043V7.4043H8.40137V8.4043V9.4043H10.8154V8.4043ZM7.58691 8.4043V7.4043H5.18457V8.4043V9.4043H7.58691V8.4043ZM5.18457 8.4043H6.18457V7.5957H5.18457H4.18457V8.4043H5.18457ZM5.18457 7.5957V8.5957H7.58691V7.5957V6.5957H5.18457V7.5957ZM7.58691 7.5957V8.5957H8.40137V7.5957V6.5957H7.58691V7.5957ZM8.40137 8.4043V7.4043H7.58691V8.4043V9.4043H8.40137V8.4043Z",
    fill: "white",
    mask: "url(#path-2-inside-1_10248_2012)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "res/media/remove.315f515ccd36a1205c62ae71b1958a50.svg";
export { ForwardRef as ReactComponent };